/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_SuccessInputs */

const en_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event text and metadata copied successfully`)
};

const fr_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte et métadonnées de l'événement copiés avec succès`)
};

const de_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext und Metadaten erfolgreich kopiert`)
};

const it_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo e metadati dell'evento copiati con successo`)
};

const ru_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст и метаданные события успешно скопированы`)
};

const es_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto y metadatos del evento copiados correctamente`)
};

const zh_cn2_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件文本和元数据复制成功`)
};

const ja_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストとメタデータをコピーしました`)
};

const hi_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट और मेटाडेटा सफलतापूर्वक कॉपी किए गए`)
};

const pt_pt2_copy_event_text_success = /** @type {(inputs: Copy_Event_Text_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto e metadados do evento copiados com sucesso`)
};

/**
* | output |
* | --- |
* | "Event text and metadata copied successfully" |
*
* @param {Copy_Event_Text_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_success = /** @type {((inputs?: Copy_Event_Text_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_event_text_success(inputs)
	if (locale === "de") return de_copy_event_text_success(inputs)
	if (locale === "it") return it_copy_event_text_success(inputs)
	if (locale === "ru") return ru_copy_event_text_success(inputs)
	if (locale === "es") return es_copy_event_text_success(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_event_text_success(inputs)
	if (locale === "ja") return ja_copy_event_text_success(inputs)
	if (locale === "hi") return hi_copy_event_text_success(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_event_text_success(inputs)
	return en_copy_event_text_success(inputs)
});